import { useEffect, useState } from 'react';

import { captureException } from '@sentry/react';

import { LoadingOverlay } from '~src/components/LoadingScreen';
import { OverlayModal } from '~src/components/Modal/OverlayModal';
import { SendOfferModal } from '~src/components/Modal/sendOffer';
import { useCustomerContext } from '~src/context/CustomerContext';
import { useDisplayContext } from '~src/context/DisplayContext';
import { SelectedProductTypeContextProvider } from '~src/context/selectedProductTypeContext';
import { useEstimatePage } from '~src/hooks/EstimatePage/useEstimatePage';
import { useEstimatePageResidenceAndProducts } from '~src/hooks/EstimatePage/useEstimatePageResidenceAndProducts';
import { formatSendOffersParameters, useInsertAndSendOffers } from '~src/hooks/graphql/useOffer';
import { useCookie } from '~src/hooks/useCookie';
import { useDisplay } from '~src/hooks/useDisplay';
import { useFinancingProvider } from '~src/hooks/useFinancingProvider';
import { useAnalytics } from '~src/tracking/ga';

import { EstimatePageDesktopBodil } from './desktop';
import { EstimatePageMobileBodil } from './mobile';

export const EstimatePage = () => {
  const estimatePageProps = useEstimatePage();

  const { address, selectedProductTypes, setSelectedProductTypes, products, residence, disabledProducts, takeover } =
    estimatePageProps;

  const { automaticQuoteSent } = useAnalytics();

  const [delayPageLoad, setDelayPageLoad] = useState(true);

  const { isMobile } = useDisplay();

  const { isFetchingBbrData } = useEstimatePageResidenceAndProducts();

  const { leadOrigin } = useDisplayContext();

  const { customer } = useCustomerContext();

  const { provider: financingProvider } = useFinancingProvider();

  const { insertOffers: sendOffers } = useInsertAndSendOffers();

  const [sendOfferModalVisible, setSendOfferModalVisible] = useState(true);

  const { cookie: utmCookie } = useCookie('utmFields');
  const { cookie: gclidCookie } = useCookie('gclid');

  const handleSendOfferModalConfirm = async () => {
    try {
      automaticQuoteSent(customer?.email ?? undefined, leadOrigin);
    } catch (error) {
      captureException(error);
    }

    sendOffers(
      formatSendOffersParameters({
        residence,
        address,
        customer: { ...customer, utmFields: utmCookie ? JSON.parse(utmCookie) : undefined, googleClickId: gclidCookie },
        leadOrigin,
        financingProvider,
        selectedProductTypes,
        offerProducts: products,
      })
    );

    setSendOfferModalVisible(false);
  };

  setTimeout(() => {
    setDelayPageLoad(false);
  }, 2000);

  useEffect(() => {
    if (disabledProducts.length > 1) {
      setSendOfferModalVisible(false);
    } else {
      setSendOfferModalVisible(true);
    }
  }, [disabledProducts.length]);

  return (
    <SelectedProductTypeContextProvider
      value={{ selectedProductTypes, setSelectedProductTypes, disabledProducts, takeover }}
    >
      {isMobile ? (
        <EstimatePageMobileBodil {...estimatePageProps} />
      ) : (
        <EstimatePageDesktopBodil {...estimatePageProps} />
      )}

      {isFetchingBbrData || delayPageLoad ? (
        <LoadingOverlay />
      ) : (
        <OverlayModal background='blurWhite' visible={sendOfferModalVisible}>
          <SendOfferModal visible={sendOfferModalVisible} onConfirm={handleSendOfferModalConfirm} />
        </OverlayModal>
      )}
    </SelectedProductTypeContextProvider>
  );
};
